import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroFechamentoCaixa from '../../../actions/fechamento-caixa/adicionarFiltroFechamentoCaixa'
import removerFiltroFechamentoCaixa from '../../../actions/fechamento-caixa/removerFiltroFechamentoCaixa'
import {
  FILTRO_VENDEDORES, FILTRO_DATA_FECHAMENTO, FILTRO_SITUACAO_FECHAMENTO
} from '../../../util/filtros'
import { alterouEmpresa } from '../../../actions/empresa/alterarEmpresaSelecionada';
import FiltroChaveValor from '../../comum/FiltroChaveValor';
import {
  getAdminEmpresa,
  getFinanceiroAgencia,
  getGestorEmpresa,
  getOperadorEmpresa,
  PERFIL_ADMIN
} from '../../../security/securityContext';
import Autorizacao from '../../../security/Autorizacao';
import FiltroBuscaFechamentoCaixa from '../FiltroBuscaFechamentoCaixa';
import listarFiltrosFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/listarFiltrosFechamentoCaixa';

export class FiltroFechamentoCaixa extends Component {
  componentDidMount () {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosFechamentoCaixa(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosFechamentoCaixa(this.props.empresaSelecionada.id)
    }
  }


  adicionarFiltro (filtro) {
    this.props.adicionarFiltroFechamentoCaixa(filtro)
  }

  removerFiltro (filtro) {
    this.props.removerFiltroFechamentoCaixa(filtro)
  }

  render () {
    if (!this.props.vendedores) {
      return <div>Carregando...</div>
    }

    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscaFechamentoCaixa
            filtro={FILTRO_DATA_FECHAMENTO}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />

          <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]}>
            <FiltroChaveValor
              filtro={FILTRO_VENDEDORES}
              opcoes={this.props.vendedores}
              filtrosAdicionados={this.props.filtrosAdicionados}
              adicionarFiltro={this.adicionarFiltro.bind(this)}
              removerFiltro={this.removerFiltro.bind(this)}
            />
          </Autorizacao>
          <FiltroChaveValor
            filtro={FILTRO_SITUACAO_FECHAMENTO}
            opcoes={this.props.situacoesFechamento}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  vendedores: state.filtrosFechamentoCaixa.vendedores,
  situacoesFechamento: state.filtrosFechamentoCaixa.situacoesFechamento,
  filtrosAdicionados: state.filtrosAdicionadosFechamentoCaixa,
  empresaSelecionada: state.empresaSelecionada,
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroFechamentoCaixa,
    removerFiltroFechamentoCaixa,
    listarFiltrosFechamentoCaixa
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroFechamentoCaixa)
